import { Component, ErrorInfo, ReactElement, ReactNode } from 'react';

import Debug from 'utils/debug';

interface ErrorBoundaryProps {
    fallback?: ReactNode;
    children: ReactElement;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean }> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(): { hasError: boolean } {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        const child = this.props.children;
        Debug.log('error out', 'ErrorBoundary', {
            name: error.name,
            message: error.message,
            stack: error.stack,
            info: errorInfo.componentStack,
            componentName: typeof child.type === 'function' ? child.type.name : null,
        });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
